import { useTranslation } from 'react-i18next';
import { Flex, Heading, Text } from '@radix-ui/themes';
import { WizardScreen } from '@/components/layout';
import { ContinueButton, OnboardingWizardHeader } from '@/components/onboarding';
import { useOnboardingStore } from '@/stores/onboardingStore';
import { SpotsPicker } from './SpotsPicker';
import type { OnboardingStepProps } from './types';
import { useSaveAndNext } from './useSaveAndNext';

export function SpotsStep({ flow }: OnboardingStepProps) {
  const { t } = useTranslation('onboarding');
  const selectedSpots = useOnboardingStore(state => state.selectedSpots);
  const setSelectedSpots = useOnboardingStore(state => state.setSelectedSpots);
  const saveAndNext = useSaveAndNext(flow);

  return (
    <WizardScreen header={<OnboardingWizardHeader flow={flow} onSkip={flow.skip} />}>
      <Flex direction="column" gap="4" py="2" pb="5">
        <Heading size="5" weight="light">
          {t('steps.spots.title')}{' '}
          <Text size="1" color="gray" as="span">
            {t('steps.spots.optional')}
          </Text>
        </Heading>
        <SpotsPicker value={selectedSpots} onChange={setSelectedSpots} />
        <ContinueButton onClick={saveAndNext}>{t('actions.continue')}</ContinueButton>
      </Flex>
    </WizardScreen>
  );
}
